// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.createHospitalForm_disabled__5Zva3 {
  pointer-events: none;
  opacity: 0.4;
  cursor: not-allowed;
}

.createHospitalForm_form__0SMxj .createHospitalForm_input_wrap__LCg3M {
  width: 100%;
  max-width: 450px;
  position: relative;
  margin-bottom: 15px;
  height: 65px;
}
.createHospitalForm_form__0SMxj .createHospitalForm_input_wrap__LCg3M label {
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
}
.createHospitalForm_form__0SMxj .createHospitalForm_input_wrap__LCg3M input {
  height: 40px;
  width: 100%;
  padding: 13px 8px;
  border: none;
  outline: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 1;
  margin-top: 5px;
}
.createHospitalForm_form__0SMxj .createHospitalForm_form_input_error__y8eDr input {
  border: 1px solid red !important;
}
.createHospitalForm_form__0SMxj .createHospitalForm_form_input_error__y8eDr input::placeholder {
  color: red;
}
.createHospitalForm_form__0SMxj .createHospitalForm_error_message__7BX\\+s {
  color: red;
  font-size: 12px;
  line-height: 1;
}
.createHospitalForm_form__0SMxj .createHospitalForm_choose_time__ApsnA {
  width: 100%;
  max-width: 400px;
  position: relative;
  margin-bottom: 15px;
}
.createHospitalForm_form__0SMxj .createHospitalForm_choose_time__ApsnA .createHospitalForm_title__ujHXw {
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
  padding-left: 15px;
  margin-bottom: 5px;
}
.createHospitalForm_form__0SMxj .createHospitalForm_choose_time__ApsnA .createHospitalForm_content_wrap__q10Nq {
  display: flex;
}
.createHospitalForm_form__0SMxj .createHospitalForm_choose_time__ApsnA .createHospitalForm_checkbox_wrap__IT7ei {
  display: flex;
  flex-direction: column;
}
.createHospitalForm_form__0SMxj .createHospitalForm_choose_time__ApsnA .createHospitalForm_checkbox_wrap__IT7ei label {
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  padding-left: 0;
  margin-bottom: 10px;
}
.createHospitalForm_form__0SMxj .createHospitalForm_form_button__WMxLT {
  display: block;
  margin: 0 auto;
  min-width: max-content;
  border-radius: 12px;
  padding: 10px 20px;
  background-color: var(--secondary-color);
  border: 2px solid var(--secondary-color);
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: #ffffff;
  margin-top: 20px;
  transition: all 0.3s;
  cursor: pointer;
}
.createHospitalForm_form__0SMxj .createHospitalForm_form_button__WMxLT:hover {
  background: var(--secondary-color-hover);
  border: 2px solid var(--secondary-color-hover);
  transform: scale(1.02);
  transition: all 0.3s;
}
.createHospitalForm_form__0SMxj .createHospitalForm_form_button__WMxLT:active {
  background-color: var(--secondary-color);
  border: 2px solid var(--secondary-color);
  transform: scale(0.98);
  transition: all 0.3s;
}
@media screen and (max-width: 991px) {
  .createHospitalForm_form__0SMxj .createHospitalForm_input_wrap_update__T6gBN {
    margin-left: 15px;
    max-width: 350px;
  }
  .createHospitalForm_form__0SMxj .createHospitalForm_choose_time_update__LKSyQ {
    margin-left: 15px;
  }
}
@media screen and (max-width: 650px) {
  .createHospitalForm_form__0SMxj .createHospitalForm_input_wrap__LCg3M {
    width: 93%;
    max-width: 93%;
    margin-bottom: 5px;
  }
  .createHospitalForm_form__0SMxj .createHospitalForm_choose_time__ApsnA {
    width: 100%;
    max-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/Forms/CreateHospitalForm/createHospitalForm.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,YAAA;EACA,mBAAA;AACF;;AAGE;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AAAJ;AAEI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAAN;AAGI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AADN;AAMI;EACE,gCAAA;AAJN;AAMM;EACE,UAAA;AAJR;AASE;EACE,UAAA;EACA,eAAA;EACA,cAAA;AAPJ;AAUE;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EAEA,mBAAA;AATJ;AAWI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AATN;AAWI;EACE,aAAA;AATN;AAYI;EACE,aAAA;EACA,sBAAA;AAVN;AAYM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AAVR;AAeE;EACE,cAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;EACA,wCAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AAbJ;AAeI;EACE,wCAAA;EACA,8CAAA;EACA,sBAAA;EACA,oBAAA;AAbN;AAgBI;EACE,wCAAA;EACA,wCAAA;EACA,sBAAA;EACA,oBAAA;AAdN;AAkBE;EACE;IACE,iBAAA;IACA,gBAAA;EAhBJ;EAkBE;IACE,iBAAA;EAhBJ;AACF;AAmBE;EACE;IACE,UAAA;IACA,cAAA;IACA,kBAAA;EAjBJ;EAmBE;IACE,WAAA;IACA,eAAA;EAjBJ;AACF","sourcesContent":[".disabled {\n  pointer-events: none;\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.form {\n  .input_wrap {\n    width: 100%;\n    max-width: 450px;\n    position: relative;\n    margin-bottom: 15px;\n    height: 65px;\n\n    label {\n      font-size: 16px;\n      font-weight: 600;\n      line-height: 1;\n    }\n\n    input {\n      height: 40px;\n      width: 100%;\n      padding: 13px 8px;\n      border: none;\n      outline: none;\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 1;\n      margin-top: 5px;\n    }\n  }\n\n  .form_input_error {\n    input {\n      border: 1px solid red !important;\n\n      &::placeholder {\n        color: red;\n      }\n    }\n  }\n\n  .error_message {\n    color: red;\n    font-size: 12px;\n    line-height: 1;\n  }\n\n  .choose_time {\n    width: 100%;\n    max-width: 400px;\n    position: relative;\n\n    margin-bottom: 15px;\n\n    .title {\n      font-size: 16px;\n      font-weight: 600;\n      line-height: 1;\n      padding-left: 15px;\n      margin-bottom: 5px;\n    }\n    .content_wrap {\n      display: flex;\n    }\n\n    .checkbox_wrap {\n      display: flex;\n      flex-direction: column;\n\n      label {\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 1;\n        padding-left: 0;\n        margin-bottom: 10px;\n      }\n    }\n  }\n\n  .form_button {\n    display: block;\n    margin: 0 auto;\n    min-width: max-content;\n    border-radius: 12px;\n    padding: 10px 20px;\n    background-color: var(--secondary-color);\n    border: 2px solid var(--secondary-color);\n    text-transform: uppercase;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 16px;\n    color: #ffffff;\n    margin-top: 20px;\n    transition: all 0.3s;\n    cursor: pointer;\n\n    &:hover {\n      background: var(--secondary-color-hover);\n      border: 2px solid var(--secondary-color-hover);\n      transform: scale(1.02);\n      transition: all 0.3s;\n    }\n\n    &:active {\n      background-color: var(--secondary-color);\n      border: 2px solid var(--secondary-color);\n      transform: scale(0.98);\n      transition: all 0.3s;\n    }\n  }\n\n  @media screen and (max-width: 991px) {\n    .input_wrap_update {\n      margin-left: 15px;\n      max-width: 350px;\n    }\n    .choose_time_update {\n      margin-left: 15px;\n    }\n  }\n\n  @media screen and (max-width: 650px) {\n    .input_wrap {\n      width: 93%;\n      max-width: 93%;\n      margin-bottom: 5px;\n    }\n    .choose_time {\n      width: 100%;\n      max-width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"disabled": `createHospitalForm_disabled__5Zva3`,
	"form": `createHospitalForm_form__0SMxj`,
	"input_wrap": `createHospitalForm_input_wrap__LCg3M`,
	"form_input_error": `createHospitalForm_form_input_error__y8eDr`,
	"error_message": `createHospitalForm_error_message__7BX+s`,
	"choose_time": `createHospitalForm_choose_time__ApsnA`,
	"title": `createHospitalForm_title__ujHXw`,
	"content_wrap": `createHospitalForm_content_wrap__q10Nq`,
	"checkbox_wrap": `createHospitalForm_checkbox_wrap__IT7ei`,
	"form_button": `createHospitalForm_form_button__WMxLT`,
	"input_wrap_update": `createHospitalForm_input_wrap_update__T6gBN`,
	"choose_time_update": `createHospitalForm_choose_time_update__LKSyQ`
};
export default ___CSS_LOADER_EXPORT___;
